// extracted by mini-css-extract-plugin
export default {"resend_btn":"nonConfirmEmail_resend_btn__Np68i"};